import { useState, useEffect } from "react";
import { fetchPlayerPositions } from "../../../services/player-service";

export const usePositionChart = ({ playerId, year, division }) => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!playerId || !year) {
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchPlayerPositions(playerId, year, division, controller.signal);
        if (controller.signal.aborted) return;
        setSummary(Array.isArray(data.summary) ? data.summary : []);
      } catch (e) {
        if (e?.name === "AbortError") return;
        setError(e?.message || "Failed to load position data");
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [playerId, year, division]);

  return { summary, loading, error };
};
